import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import tenantStorage from '../../services/tenantStorage';

/**
 * Redirects to the Functions page if there is no active business day.
 * Used to block direct-URL access to function pages that require an open
 * business day (Table Service, KDS, Waiter Sales). Cashier Sales is exempt —
 * it is where the business day is started.
 */
const useBusinessDayGuard = () => {
    const navigate = useNavigate();
    useEffect(() => {
        let active = true;
        (async () => {
            try {
                const state = await tenantStorage.getBusinessDayState();
                if (active && !state?.isBusinessDay) {
                    navigate('/functions', { replace: true });
                }
            } catch (e) {
                console.error('Business day guard check failed:', e);
            }
        })();
        return () => { active = false; };
    }, [navigate]);
};

export default useBusinessDayGuard;
